import { match } from './match';
import { HEADLINE_KEYPHRASES } from '@frontend/store/psd-layers/features/auto-map/constants/keyphrases';

const HEADLINE_ACTIVATOR_REGEX = /headline/i;

const matcher = ({ targetName, sourceName }) => match({
  targetName,
  sourceName,
  keyPhrases: HEADLINE_KEYPHRASES,
  options: { includeNumber: true }
});

export const headlineMatcher = {
  match: matcher,
  activator: (elementName) => !!elementName.match(HEADLINE_ACTIVATOR_REGEX)
}